'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";

import {FaBars, FaTimes} from "react-icons/fa";

import Button from "react-bootstrap/Button";

import appNavigationStore from "./AppNavigationStore";
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import Broken from "@uw-it-sis/lib-react/lib/Broken";
import UnknownState from "@uw-it-sis/lib-react/lib/UnknownState";

/**
 * The navigation toggle button.
 */
class AppNavigationToggle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.store = appNavigationStore;

        // Bind this to click handlers.
        this.pageClick = this.pageClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    pageClick = (event) => {
        const appNavigation = document.getElementById("app-navigation");

        if ( appNavigation !== null ) {
            const target = event.target ? event.target : event.srcElement;
            const appNavigationToggle = document.getElementById("app-navigation-toggle");

            let isTargetInsideNav = appNavigation.contains(target) || appNavigationToggle.contains(target);
            // If the click is outside the nav elements, then close the navigation.
            if (!isTargetInsideNav) {
                document.body.classList.remove("nav-expanded");
                this.setState({
                    expanded: false
                });
                window.removeEventListener('mousedown', this.pageClick, false);
            }
        }
    };

    handleClick = () => {
        const appNavigation = document.getElementById("app-navigation");
        if ( appNavigation !== null ) {
            // If the navigation is OPEN
            if (document.body.classList.contains("nav-expanded")) {
                document.body.classList.remove("nav-expanded");
                this.setState({
                    expanded: false
                });
            } else {
                document.body.classList.add("nav-expanded");
                this.setState({
                    expanded: true
                });
                window.addEventListener('mousedown', this.pageClick, false);
                // a11y: Set focus on first link within navigation when opened
                document.querySelectorAll('#app-navigation a')[0].focus();
            }
        }
    };

    render() {
        let component = null;

        switch (this.store.state) {
            case States.unauthenticated:
            case States.initial:
            case States.pending:
                component = <span className="sr-only">Loading Navigation</span>;
                break;

            case States.done:
                const ToggleIcon = this.state.expanded ? FaTimes : FaBars;
                component =
                    <Button id="app-navigation-toggle"
                            variant="outline-white"
                            onClick={this.handleClick}
                            aria-label="Navigation Toggle"
                            className="me-4 p-2 d-print-none d-flex align-items-center">
                        <ToggleIcon className="fs-5" aria-hidden={true} />
                    </Button>
                break;

            case States.error:
                component = <Broken name="RegistrationTermButton"/>;
                break;

            default:
                component = <UnknownState name="RegistrationTermButton"/>;
        }

        return component;
    }
}

export default observer(AppNavigationToggle);